module.exports = __webpack_public_path__ + "static/media/universitysidebar.1945b9ec.png";